import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "menu-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M3.00049 5.2522C2.58627 5.2522 2.25049 5.58798 2.25049 6.0022C2.25049 6.41641 2.58627 6.7522 3.00049 6.7522H21C21.4142 6.7522 21.75 6.41641 21.75 6.0022C21.75 5.58798 21.4142 5.2522 21 5.2522H3.00049Z" }, null, -1),
    _createElementVNode("path", { d: "M2.25049 11.9998C2.25049 11.5855 2.58627 11.2498 3.00049 11.2498H21C21.4142 11.2498 21.75 11.5855 21.75 11.9998C21.75 12.414 21.4142 12.7498 21 12.7498H3.00049C2.58627 12.7498 2.25049 12.414 2.25049 11.9998Z" }, null, -1),
    _createElementVNode("path", { d: "M2.25049 17.9978C2.25049 17.5836 2.58627 17.2478 3.00049 17.2478H21C21.4142 17.2478 21.75 17.5836 21.75 17.9978C21.75 18.412 21.4142 18.7478 21 18.7478H3.00049C2.58627 18.7478 2.25049 18.412 2.25049 17.9978Z" }, null, -1)
  ])))
}
export default { render: render }